import styles from './index.module.scss';

export interface AbilityCardProps {
  icon: string;
  title: string;
  description: string;
}

export default function AbilityCard({ icon, title, description }: AbilityCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrap}>
        <img src={icon} alt={title} loading="lazy" />
      </div>
      <div className={styles.text}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.desc}>{description}</p>
      </div>
    </div>
  );
}
